import editIconFile from '../img/uEA1C-edit-32x32.png';
import addIconFile from '../img/uEA76-zoomin-32x32.png';
import permIconFile from '../img/uEA6A-usergroup-32x32.png';
import deleteIconFile from '../img/uEA14-delete-32x32.png';
import serverIconFile from '../img/uEA56-server-32x32.png';
import subscribeIconFile from '../img/uEA96-agreement-32x32.png';
import signIconFile from '../img/uEA5A-sign-32x32.png';
import tileIconFile from '../img/uEA7D-tiles-32x32.png';
import saveIconFile from '../img/uEA52-save-32x32.png';
import cancelIconFile from '../img/uEA0A-cancel-32x32.png';
import pageBackIconFile from '../img/chevron-left-4x.png';
import placeholderImage from '../img/baseline_add_photo_alternate_black_48dp.png';
import defaultExtensionIconFile from '../img/baseline_extension_black_36dp.png';
import createSystemBackgroundFile from '../img/cja-create-system.png';
import successFlagBackgroundFile from '../img/cja-success-flag.png';
import landingPageBackgroundFile from '../img/cja-login.png'
import dvLogoSWFile from '../img/dvlogo-sw.png';
import moveIconFile from '../img/outline_drive_file_move_black_24dp.png';
import overwriteIconFile from '../img/assistant_direction_FILL0_wght400_GRAD0_opsz48.png';

export var editIcon = editIconFile;
export var addIcon = addIconFile;
export var permIcon = permIconFile;
export var deleteIcon = deleteIconFile;
export var serverIcon = serverIconFile;
export var subscribeIcon = subscribeIconFile;
export var signIcon = signIconFile;
export var tileIcon = tileIconFile;
export var saveIcon = saveIconFile;
export var cancelIcon = cancelIconFile;
export var defaultExtensionIcon = defaultExtensionIconFile;
export var dvLogo = dvLogoSWFile;
export var createSystemBackground = createSystemBackgroundFile;
export var successFlagBackground = successFlagBackgroundFile;
export var landingPageBackground = landingPageBackgroundFile;
export var moveOrgaIcon = moveIconFile;
export var overwriteIcon = overwriteIconFile;

// 3rd-Party
// source: https://useiconic.com/open
import cardIconFile from '../img/grid-three-up-2x.png';
import listIconFile from '../img/list-2x.png';
import providerIconFile from '../img/command-4x.png';

export var cardIcon = cardIconFile;
export var listIcon = listIconFile;
export var providerIcon = providerIconFile;
export var pageBackIcon = pageBackIconFile;

export var placeholderEmptyImage = placeholderImage;